var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rows.length)?_c('div',{staticClass:"engine-details"},_vm._l((_vm.rows),function(row){return _c('div',{key:row.key,staticClass:"engine-details__row"},[_c('span',{staticClass:"engine-details__label"},[_vm._v(_vm._s(row.label))]),_c('span',{staticClass:"engine-details__value"},[_vm._v(_vm._s(row.value))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }